'use strict';

angular.module('Services')
    .service('Request', function ($http, $rootScope, Error, Upload, $filter, RequestsRepo, toastr, deviceDetector, $location) {
        let geoIp = '{}';
        let resellerId;
        var errorsCallback = function (data, err, callback) {
            var response = {};
            switch (err) {
                case 400:
                    response = {
                        fieldErrors: Error.errorConverter(data['fieldErrors']),
                        message: data.message,
                        code: data.code
                    };
                    callback ? callback(response) : false;
                    break;
                case 401:
                    const error = data ? data['error_description'] : '401 error';
                    $rootScope.logOut(null, 401, error);
                    break;
                case 403:
                    response = {
                        message: data['error_description'],
                        code: 'Access Error'
                    };
                    callback ? callback(response) : false;
                    break;
                case 404:
                    response = {
                        code: data.code,
                        message: data.message
                    };
                    callback ? callback(response) : false;
                    break;
                case 412:
                    response = {
                        code: data.code,
                        message: data.message
                    };
                    callback ? callback(response) : false;
                    break;
                case -1:
                    break;
                default:
                    response = {
                        code: err,
                        message: 'Contact administrator if this error will occur again'
                    };
                    callback ? callback(response) : false;
                    //Error.serverError('Error #' + err);
                    break;
            }
        };
        function buildFilters(opts) {
            let data = [];

            const filters = opts['data'] ? JSON.parse(JSON.stringify(opts['data'])) : [];

            for (let i in filters) {
                if (i === 'createdDate' || i === 'deliveredDate' || i === 'bookingDate' || i === 'manifestedDate') {
                    if (opts['data'][i][0]) {
                        var dateTemp = $filter('date')(new Date(opts['data'][i][0]), 'yyyy-MM-dd 00:00:00 Z');
                        data.push(i + '=' + encodeURIComponent(dateTemp));
                    }
                    if (opts['data'][i][1]) {
                        let dateTemp = $filter('date')(new Date(opts['data'][i][1]), 'yyyy-MM-dd 23:59:59 Z');
                        data.push(i + '=' + encodeURIComponent(dateTemp));
                    } else {
                        let dateTemp = $filter('date')(new Date(opts['data'][i][0]), 'yyyy-MM-dd 23:59:59 Z');
                        data.push(i + '=' + encodeURIComponent(dateTemp));
                    }
                }
                else if (angular.isArray(opts['data'][i])) {
                    opts['data'][i].forEach(item => {
                        data.push(i + '=' + item);
                    });
                }
                else {
                    data.push(i + '=' + opts['data'][i]);
                }
            }

            if (resellerId && !opts['disableResellerFilter']) {
                data.push('reseller_id=' + resellerId);
            }

            return data;
        }
        function get(opts) {
            var params = opts['params'] || {};
            params['url'] = opts['url'];
            params['method'] = 'GET';
            params['cache'] = opts['cache'] || false;
            let data = buildFilters(opts);
            params['url'] += data.length ? '?' + data.join('&') : '';
            let httpParams = params;
            if (!opts.disableAbort) {
                RequestsRepo.storeRequest(params, opts['successCallback']);
                httpParams = RequestsRepo.getStored(params, opts['successCallback']);
            }
            $http(httpParams).success(function (data) {
                opts['successCallback'] ? opts['successCallback'](data) : false;
            }).error(function (data, err) {
                errorsCallback(data, err, opts['errorCallback']);
            }).then(function (response) {
                opts['doneCallback'] ? opts['doneCallback'](response) : false;
            }).finally(function () {
                RequestsRepo.endRequest(params);
            });
        }
        function post(opts, dataFields) {
            let data = buildFilters(opts);
            let url = opts.url + (data.length ? '?' + data.join('&') : '');
            $http({
                url: url,
                method: opts['method'] || 'PUT',
                data: dataFields
            }).success(function (data) {
                // sendLog(opts, opts.method || 'PUT', dataFields, geoIp);
                opts['successCallback'] ? opts['successCallback'](data) : false;
            }).error(function (data, err) {
                errorsCallback(data, err, opts['errorCallback']);
            });
        }

        function sendLog(data, method, requestData, geoIp) {
            if (data.url === ApiURLs.logging)
                return false;
            var logPayload = {
                "request": method + ' ' + data.url,
                //"payload": requestData,
                "path": window.location.pathname,
                "geoip": geoIp,
                "userId": $rootScope.GlobalProfile.id
            };
            post({
                url: ApiURLs.logging,
                method: 'POST'
            }, logPayload);
        }

        function setRequestAsClient(client) {
            resellerId = client.id;
        }

        function getGeoIp() {
            this.get({
                url: ApiURLs.ipStack,
                method: 'GET',
                successCallback: (data) => {
                    geoIp = JSON.stringify(data);
                },
                errorCallback: (error) => {
                    console.log(error);
                }
            })
        }
        return {
            get: get,
            post: post,
            getGeoIp: getGeoIp,
            delete: function (opts, dt) {
                $http({
                    url: opts['url'],
                    method: opts['method'] || 'DELETE',
                    data: dt,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).success(function (data) {
                    opts['successCallback'] ? opts['successCallback'](data) : false;
                    Error.successMessage();
                    sendLog(opts, opts.method || 'PUT', null, geoIp);
                }).error(function (data, err) {
                    errorsCallback(data, err, opts['errorCallback']);
                });
            },
            upload: function (opts, file) {
                let data = [];
                const filters = opts['data'] ? JSON.parse(JSON.stringify(opts['data'])) : [];
                for (let i in filters) {
                    data.push(i + '=' + opts['data'][i]);
                }
                opts['url'] += data.length ? '?' + data.join('&') : '';
                Upload.upload({
                    url: opts['url'],
                    data: {
                        [opts.fileKey || 'file']: Upload.rename(file, '')
                    },
                    method: opts['method'],
                    headers: opts.headers || {}
                }).then(data => {
                    sendLog(opts, opts.method || 'PUT', null, geoIp);
                    opts['successCallback'] ? opts['successCallback'](data.data) : false;
                }, response => {
                    errorsCallback(response.data, response.status, opts['errorCallback']);
                }, evnt => {
                    console.log(evnt);
                    opts['eventCallback'] ? opts['eventCallback'](evnt) : false;
                }).catch(err => {
                    console.log(err);
                });
            },
            uploadHttp: function (opts, file) {
                var formData = new FormData();
                formData.append('photo', file);
                $http({
                    url: opts['url'] + '?isVehiclePhoto=false',
                    method: 'POST',
                    data: formData,
                    responseType: 'text',
                    headers: { 'Content-Type': undefined }
                }).success(function (data) {
                    opts['successCallback'] ? opts['successCallback'](data) : false;
                    Error.successMessage();
                }).error(function (data, err) {
                    errorsCallback(data, err, opts['errorCallback']);
                })
            },
            getFile: function (opts, dataFields) {
                var data = [];
                const filters = opts['data'] ? JSON.parse(JSON.stringify(opts['data'])) : [];

                for (var i in filters) {

                    data.push(i + '=' + opts['data'][i]);
                }
                var params = {
                    url: opts['url'] + (data.length ? '?' + data.join('&') : ''),
                    method: opts.method || 'GET',
                    data: dataFields,
                    responseType: 'blob'
                };
                $http(params).success(function (data, status, headers, config) {
                    var url = (window.URL || window.webkitURL).createObjectURL(data);
                    const contentDisposition = headers('Content-Disposition');
                    successCallback(data, contentDisposition)
                }).error(function (data, err) {
                    errorsCallback(data, err, opts['errorCallback']);
                });

                var successCallback = function (data, contentDisposition) {
                    if (opts["fileType"] === 'application/pdf') {
                        let fileName = opts['fileName'] + '.pdf';
                        if (contentDisposition) {
                            fileName = contentDisposition.split("=")[1].replace(/"/g, '');
                        }
                        opts["fileName"] = fileName;
                    }

                    download(data, opts.fileName, data.fileType);
                    opts['successCallback'] ? opts['successCallback'](url) : false;
                }
            },
            downloadFile: function (options) {
                var params = {
                    url: options['url'],
                    method: options['method'] ? options['method'] : 'PUT',
                    data: options['data'],
                    responseType: options['responseType'],
                    headers: options['headers'] || {}
                };
                var successCallback = function (data) {
                    download(data, options["fileName"], options["fileType"]);
                    options['successCallback'] ? options['successCallback'](data) : false;
                };
                if (!options['errorCallback']) options['errorCallback'] = function (err) {
                    if (err.message) {
                        toastr.error(err.message, 'Error');
                    }
                };
                $rootScope.sendRequest = true;
                $http(params).success(function (data) {
                    successCallback(data);
                }).error(function (data, err) {
                    var decoder = new TextDecoder("utf-8");
                    data = JSON.parse(decoder.decode(new Uint8Array(data)) || '""');
                    errorsCallback(data, err, options['errorCallback']);
                }).finally(function (response) {
                    options['doneCallback'] ? options['doneCallback'](response) : false;
                    $rootScope.sendRequest = false;
                });
            },
            exportFile: function (options, requestData) {
                var params = {
                    url: options['url'],
                    method: 'POST',
                    data: requestData,
                    responseType: options['responseType']
                };

                if (options['contentType']) {
                    params.headers = {
                        'Accept': options['fileType'],
                        'Content-Type': options['contentType']
                    };
                } else {
                    params.headers = {
                        'Accept': options['fileType']
                    }
                }

                options['successCallbackInside'] = function (data) {
                    var blob = new Blob([data], { type: (options['fileType'] || 'text/plain') + ';charset=utf-8' });
                    if (deviceDetector.raw.os.ios) {
                        var fileURL = URL.createObjectURL(blob);
                        document.location.href = fileURL;
                    } else {
                        if (options['isSentViaEmail']) { return; }
                        download(data, options["fileName"], options["fileType"]);
                    }
                };
                var data = [];
                for (var i in options['data']) {
                    if (i == 'createdDate') {
                        if (options['data'][i][0]) {
                            var date = options['data'][i][0].replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1');
                            date = $filter('date')(new Date(date), 'yyyy-MM-dd 00:00:00 Z');
                            data.push(i + '=' + encodeURIComponent(date));
                        }
                        if (options['data'][i][1]) {
                            var date;
                            // Check if date type object or string
                            if (typeof options['data'][i][1] != 'string') {
                                date = options['data'][i][1].toString().replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1');
                            } else {
                                date = options['data'][i][1].replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1');
                            }

                            date = $filter('date')(new Date(date.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')), 'yyyy-MM-dd 23:59:59 Z');
                            data.push(i + '=' + encodeURIComponent(date));
                        } else {
                            if (options['data'][i][0]) {
                                var date = options['data'][i][0].replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1');
                                date = $filter('date')(new Date(date), 'yyyy-MM-dd 23:59:59 Z');
                                data.push(i + '=' + encodeURIComponent(date));
                            }
                        }
                    } else {
                        data.push(i + '=' + encodeURIComponent(options['data'][i]));
                    }
                }
                params['url'] += data.length ? '?' + data.join('&') : '';
                $rootScope.sendRequest = true;
                $http(params).success(function (data) {
                    options['successCallbackInside'] ? options['successCallbackInside'](data) : false;
                    options['successCallback'] ? options['successCallback'](data) : false;
                }).error(function (data, err) {
                    var decoder = new TextDecoder("utf-8");
                    var dataJson = decoder.decode(new Uint8Array(data));
                    if (dataJson) {
                        data = JSON.parse(dataJson);
                        if (data.message) {
                            //toastr.error(data.message, 'Error');
                        }
                    }
                    errorsCallback(data, err, options['errorCallback']);
                }).finally(function (response) {
                    options['doneCallback'] ? options['doneCallback'](response) : false;
                    $rootScope.sendRequest = false;
                });
            },
            setRequestAsClient
        }
    })
    .factory('Error', function () {
        return {
            errorConverter: function (errors) {
                if (!errors) {
                    return {};
                }
                var newErrors = {};
                for (var i = 0; i < errors.length; i++) {
                    newErrors[errors[i]['field']] = errors[i]['message'];
                }
                return newErrors;
            },
            successMessage: function () {
                console.log('Success');
            },
            serverError: function (msg) {
                console.log(msg || 'Server Error');
            },
            formError: function (data) {

            }
        };
    });



// WEBPACK FOOTER //
// ./js/services/request.js